import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  subtitle?: string;
  content: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  index?: number;
}
export const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  subtitle,
  content,
  isOpen,
  onClick,
  index
}) => {
  return <div className="border border-gray-200 rounded-lg mb-2.5 md:mb-4 bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-481">
      <button className="w-full text-left px-4 py-3 md:px-6 md:py-5 flex items-center justify-between focus:outline-none" onClick={onClick} data-id="element-482">
        <div className="flex items-center gap-2.5 md:gap-4 pr-2 md:pr-4" data-id="element-483">
          {index !== undefined && <span className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold font-serif text-sm md:text-base" data-id="element-484">
              {index}
            </span>}
          <div data-id="element-485">
            <h3 className="font-serif text-base md:text-xl font-bold text-gray-900" data-id="element-486">
              {title}
            </h3>
            {subtitle && <p className="text-primary font-medium mt-0.5 text-xs md:text-sm" data-id="element-487">
                {subtitle}
              </p>}
          </div>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 text-gray-400" data-id="element-488">
          <ChevronDown size={20} className="md:hidden" data-id="element-489" />
          <ChevronDown size={24} className="hidden md:block" data-id="element-490" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-491">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-492">
            <div className="px-4 pb-4 md:px-6 md:pb-6 pt-2 text-sm md:text-base text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-493">
              {content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
interface AccordionProps {
  items: Omit<AccordionItemProps, 'isOpen' | 'onClick'>[];
  allowMultiple?: boolean;
}
export const Accordion: React.FC<AccordionProps> = ({
  items,
  allowMultiple = false
}) => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const handleItemClick = (index: number) => {
    if (allowMultiple) {
      setOpenIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    } else {
      setOpenIndexes(prev => prev.includes(index) ? [] : [index]);
    }
  };
  return <div className="w-full max-w-3xl mx-auto" data-id="element-494">
      {items.map((item, index) => <AccordionItem key={index} {...item} isOpen={openIndexes.includes(index)} onClick={() => handleItemClick(index)} data-id="element-495" />)}
    </div>;
};